export default "__VITE_ASSET__mz$cfKBP__"